/* eslint-disable */
import { AUTH_HELP_LINK_CLICKED } from '../Auth.types';

/**
 * Auth action for help link action
 * @returns {ActionCreator<FromPromise<AuthEntity, Error, {}, AUTH_HELP_LINK_CLICKED>>} The created `Action`
 */
const authHelpLink = () => ({ fromPayload }) => {
  return fromPayload(null, {}, AUTH_HELP_LINK_CLICKED);
};

export default authHelpLink;
